import { useContext } from 'react';
import { useLocation } from 'react-router';

import { ClinicRxContext } from '../../App';
import { SocketContext } from '../SocketProvider';

const DASHBOARD_PATH = '/dashboard';

export default function useSnackbar() {
  const { state } = useContext(ClinicRxContext);
  const { snackbar } = useContext(SocketContext);
  const location = useLocation();

  const showSnackbarIfRelevant = (alertID, message) => {
    const isAlertRelevant = state.alertData.some(
      (entry) => entry.alertID === alertID,
    );
    if (isAlertRelevant) {
      snackbar.setIsOpen(true);
      snackbar.setMessage(message);
    }
  };

  const showSnackbarIfNotOnDashboard = (message) => {
    if (location.pathname !== DASHBOARD_PATH) {
      if (!snackbar.isOpen) {
        snackbar.setIsOpen(true);
        snackbar.setMessage(message);
      }
    }
  };

  return { showSnackbarIfRelevant, showSnackbarIfNotOnDashboard };
}
